import { createI18n } from 'vue-i18n';
import zh from './zh';
import en from './en';

// 从localStorage中获取保存的语言设置，如果没有则使用浏览器语言或默认中文
const getSavedLocale = () => {
  try {
    const savedLocale = localStorage.getItem('language');
    if (savedLocale && ['zh', 'en'].includes(savedLocale)) {
      return savedLocale;
    }
    // 如果没有有效的保存语言，使用浏览器语言
    return navigator.language.includes('zh') ? 'zh' : 'en';
  } catch (error) {
    console.error('Failed to get saved locale:', error);
    return 'zh'; // 默认使用中文
  }
};

const i18n = createI18n({
  legacy: false, // 使用组合式API必须设置为false
  locale: getSavedLocale(), // 当前语言
  fallbackLocale: 'zh', // 当当前语言没有对应的翻译时，回退到的语言
  messages: {
    zh,
    en
  }
});

export default i18n;